export default __webpack_public_path__ + "static/media/slider-img2.05fe7dc8.gif";